import * as React from 'react';
import * as DTOS from "../../FeralScan.dtos";
import { Link } from 'react-router-dom';

interface IFileImageThumbnailProps {
    file: DTOS.FileRecord
}

const FileImageThumbnail = React.memo<IFileImageThumbnailProps>(props => (
    <Link className="img-thumbnail d-inline-block" target="_blank" to={`/file/${props.file.fileNameWithExtension}`}>
        <img src={`/file/${props.file.fileName}_sm.${props.file.extension}`} />
    </Link>
));

export default FileImageThumbnail